import { useEffect } from 'react'

import { Amplitude } from 'services/amplitude.service'

export function useBeaconFlushOnPageHide(instance: Amplitude | null): void {
  useEffect(() => {
    if (!instance) return undefined

    const handlePageHide = (): void => {
      instance.flushWithBeacon()
    }

    window.addEventListener('pagehide', handlePageHide)

    return () => window.removeEventListener('pagehide', handlePageHide)
  }, [instance])
}
